<script>
    import { closeAllModals, openModal } from "svelte-modals";
    import { createEventDispatcher } from "svelte";
    import AlertModal from "../Modal/AlertModal.svelte";

    const dispatch = createEventDispatcher();
    export let message;
    export let buttonClass = 'w-full';
    export let buttonText = "Elimina";

    function handleDeleteButton () {
        openModal(AlertModal, {
            title: `Eliminazione `,
            message,
            confirmButtonClass: "bg-red-500",
            onConfirm: () => {
                closeAllModals()
                dispatch('delete', {});
            }
        })
    }
</script>

<button
    class="border-0 bg-red-500 p-2 px-4 font-semibold text-white transition hover:shadow-lg outline-none focus:outline-none {buttonClass}"
    on:click|preventDefault = {() => handleDeleteButton()}
>
    { buttonText }
</button>